import React from 'react'

const Policy = () => {
  return (
    <div>
      <h1>policy</h1>
    </div>
  )
}

export default Policy
